module.exports = __webpack_public_path__ + "img/sub_main_기업문화.d75ca31a.png";